<template>
  <div class="dynamic-tables">
    <h2 class="page-title">Permohonan Nonberusaha Swasta</h2>
    <Widget customHeader>
      <div v-if="user.role === 'Superuser'">
        <DataSuperuser
          ref="childAdmin"
          :baseapiPengendalian="baseapiPengendalian"
          :dataPermohonan= "dataPermohonan"
          :user="user"
          @verifPembayaran="verifPembayaran"
          :tipe="'Swasta'"
          @loadProgress="loadProgress"
          @deleteDokumen = 'deleteDokumen'
        />
      </div>
      <div v-if="user.role === 'Pemrakarsa'">
        <DataPemrakarsa
          ref="childAdmin"
          :baseapiPengendalian="baseapiPengendalian"
          :dataPermohonan= "dataPermohonan"
          :user="user"
          @verifPembayaran="verifPembayaran"
          :tipe="'Swasta'"
          @loadProgress="loadProgress"
          @deleteDokumen = 'deleteDokumen'
        />
      </div>
      <div v-if="user.role === 'Pejabat'">
        <DataPejabat
          ref="childAdmin"
          :baseapiPengendalian="baseapiPengendalian"
          :dataPermohonan= "dataPermohonan"
          :user="user"
          @verifPembayaran="verifPembayaran"
          :tipe="'Swasta'"
          @loadProgress="loadProgress"
          @deleteDokumen="deleteDokumen"
        />
      </div>
      <div>
        
      </div>
    </Widget>

    <b-modal
      body-class="bg-white"
      id="modal-pembayaran"
      title="Upload Tagihan"
      cancel-title="Close"
      ok-title="Accept"
      cancel-variant="outline-secondary"
    >
      <form
        ref="form"
        @submit.stop.prevent="tambahdata"
        data-vv-scope="form-1"
      >
        <span v-if="dataPerDokumen.file_tagihan_i === null && dataPerDokumen.file_tagihan_ii === null && dataPerDokumen.file_tagihan_iii === null">
        <legend><strong>Tagihan 1</strong></legend>
          <b-row>
              <b-col md="12">
                <b-form-group label="Tanggal Tagihan: *" label-for="username">
                  <input type="date"  v-model="dataPerDokumen.tanggal_tagihan_i" v-validate="'required'" name="Tanggal Tagihan"
                    :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.Tanggal Tagihan') }"/>
                    <span class="text-danger" v-if="errors.has('form-1.Tanggal Tagihan')">
                      {{ errors.first('form-1.Tanggal Tagihan') }}
                    </span>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="File Tagihan: *" label-for="username">
                  <b-form-file
                      placeholder="Choose a file or drop it here..."
                      drop-placeholder="Drop file here..."
                      plain
                      class="form-control"
                      v-model="dataPerDokumen.tagihan_i"
                      accept=".pdf"
                      ></b-form-file>
                </b-form-group>
                <!-- <div style="color:red; margin-top: -15px;" v-if="dataPerDokumen.file_tagihan_i === null">Tidak ada File Tagihan</div>
                <div v-else>
                    <a :href="dataPerDokumen.file_tagihan_i" style="margin-top: -15px;" target="_blank"
                        ><i class="fa fa-download" aria-hidden="true"
                    /> Unduh File Tagihan</a>
                </div> -->
              </b-col>
          </b-row>
        </span>
        <span v-else-if="dataPerDokumen.file_tagihan_i !== null && dataPerDokumen.file_tagihan_ii === null && dataPerDokumen.file_tagihan_iii === null">
        <legend><strong>Tagihan 2</strong></legend>
          <b-row>
              <b-col md="12">
                <b-form-group label="Tanggal Tagihan: *" label-for="username">
                  <input type="date"  v-model="dataPerDokumen.tanggal_tagihan_ii" v-validate="'required'" name="Tanggal Tagihan"
                    :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.Tanggal Tagihan') }"/>
                    <span class="text-danger" v-if="errors.has('form-1.Tanggal Tagihan')">
                      {{ errors.first('form-1.Tanggal Tagihan') }}
                    </span>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="File Tagihan: *" label-for="username">
                  <b-form-file
                      placeholder="Choose a file or drop it here..."
                      drop-placeholder="Drop file here..."
                      plain
                      class="form-control"
                      v-model="dataPerDokumen.tagihan_ii"
                      accept=".pdf"
                      ></b-form-file>
                </b-form-group>
                <!-- <div style="color:red; margin-top: -15px;" v-if="dataPerDokumen.file_tagihan_ii === null">Tidak ada File Tagihan</div>
                <div v-else>
                    <a :href="dataPerDokumen.file_tagihan_ii" style="margin-top: -15px;" target="_blank"
                        ><i class="fa fa-download" aria-hidden="true"
                    /> Unduh File Tagihan</a>
                </div> -->
              </b-col>
          </b-row>
        </span>
        <span v-else>
        <legend><strong>Tagihan 3</strong></legend>
          <b-row>
              <b-col md="12">
                <b-form-group label="Tanggal Tagihan: *" label-for="username">
                  <input type="date"  v-model="dataPerDokumen.tanggal_tagihan_iii" v-validate="'required'" name="Tanggal Tagihan"
                    :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.Tanggal Tagihan') }"/>
                    <span class="text-danger" v-if="errors.has('form-1.Tanggal Tagihan')">
                      {{ errors.first('form-1.Tanggal Tagihan') }}
                    </span>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="File Tagihan: *" label-for="username">
                  <b-form-file
                      placeholder="Choose a file or drop it here..."
                      drop-placeholder="Drop file here..."
                      plain
                      class="form-control"
                      v-model="dataPerDokumen.tagihan_iii"
                      accept=".pdf"
                      ></b-form-file>
                </b-form-group>
                <!-- <div style="color:red; margin-top: -15px;" v-if="dataPerDokumen.file_tagihan_iii === null">Tidak ada File Tagihan</div>
                <div v-else>
                    <a :href="dataPerDokumen.file_tagihan_iii" style="margin-top: -15px;" target="_blank"
                        ><i class="fa fa-download" aria-hidden="true"
                    /> Unduh File Tagihan</a>
                </div> -->
              </b-col>
          </b-row>
        </span>
       
      </form>
    

      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            
            style="float:right"
            @click="onSubmitPembayaran"
          >
          <i
            class="fa fa-floppy-o text-white"/>
          
            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal id="modal-tracking" title="Tracking Permohonan" size="lg" scrollable>
      <template v-if="progressPermohonan.length == 0">
        <span class="text-center">Maaf, tidak ada data</span>
      </template>
      <template v-else>
        <ul class="timeline" >
        <li v-for="(data,index) in progressPermohonan" :key="index">
          <!-- <time class="eventTime" dateTime="2014-05-19 03:04">
            <span class="date">today</span>
            <span class="time">9:41 <span class="fw-semi-bold">am</span></span>
          </time> -->
          <span class="eventIcon eventIconPrimary">
            <!-- <i class="la la-lg la-comment" /> -->
          </span>
          <section class="event">
            <span class="thumb-xs avatar pull-left me-sm-1"> </span>
            <h5 class="eventHeading">
              <!-- <a href="#" v-if="index == 0">Submit Permohonan</a> -->
              <a href="#">{{data.status_permohonan}}</a>
              
            </h5>
            <small>{{data.instansi_pemohon}}</small>

            <p class="fs-sm text-muted"> {{format_date(data.createdAt,'HH:mm - DD MMMM YYYY')}}</p>

            <div class="text-danger" v-html="data.catatan"></div>
          </section>
        </li>
      </ul>
      </template>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="danger"
            size="sm"
            class="float-right"
            @click="$bvModal.hide('modal-tracking')"
          >
            Tutup
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
  
</template>
    
    <style>
table.table.b-table > thead > tr > th[aria-sort="ascending"]::after,
table.table.b-table > tfoot > tr > th[aria-sort="ascending"]::after {
  opacity: 1;
  content: "\2191";
}

.dt-button.btn.btn-primary {
  border: none;
}

.dt-button.btn.btn-primary:hover {
  background-color: #35a0fd !important;
  border: none;
}
</style>
    
    <script>
import Widget from "@/components/Widget/Widget";
import Swal from "sweetalert2";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import vSelect from "vue-select";
import axios from "axios";
import VueLoading from "vuejs-loading-plugin";
import Vue from "vue";
import { formatDate } from "../../../helper/helpernew";
import DataSuperuser from "./DataDokumen/Superuser"
import DataPemrakarsa from "./DataDokumen/Pemrakarsa"
import DataPejabat from "./DataDokumen/Pejabat"


// using default options
Vue.use(VueLoading);

// overwrite defaults
Vue.use(VueLoading, {
  dark: true, // default false
  text: "Loading", // default 'Loading'
  loading: true, // default false
  //customLoader: myVueComponent, // replaces the spinner and text with your own
  background: "rgb(255,255,255)", // set custom background
  classes: ["myclass"], // array, object or string
});

export default {
  name: "Dynamic",
  components: { Widget, ClassicEditor, vSelect,DataSuperuser,DataPemrakarsa,DataPejabat},
  data() {
    return {
      baseapiPengendalian: localStorage.getItem("baseapiPengendalian"),
      user: JSON.parse(localStorage.getItem("userPengendalian")),
      dataPermohonan: [],
      progressPermohonan: [],
      popoverShow: {},
      dataPerDokumen: []
    };
  },

  mounted() {
    // localStorage.setItem('tipe_pemohon','Pemerintah')
    // if(this.user.role == 'superuser'){
    //   this.loaddata();
    // }
  },
  methods: {
    onClose(id) {
      this.popoverShow[id] = false;
    },
    format_date(val, format) {
      if (val) return formatDate(val, format);
    },
    loaddata() {
      axios
        .get(
          this.baseapiPengendalian +
            "api/permohonan_nonberusaha?filter=tipe_pemohon,=,Swasta",
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.dataPermohonan = response.data.data;
          console.log(this.dataPermohonan);
          this.initDatatable();
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },
    async deletePermohonan(id) {
      Swal.fire({
        title: "Apa kamu yakin?",
        text: "Anda tidak akan dapat mengembalikan data ini!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya, hapus",
        cancelButtonText: "Tutup",
      }).then(async (result) => {
        if (result.isConfirmed) {
          axios
            .delete(this.baseapiPengendalian + "api/permohonan_nonberusaha/" + id, {
              headers: {
                Authorization: `Bearer ` + this.user.accessToken,
              },
            })
            .then((response) => {
              Swal.fire("Berhasil", "" + response.data.message + "", "success");
              $("#example").DataTable().destroy();
              this.loaddata();
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    edit(id) {
      localStorage.setItem("id_permohonan", id);
      localStorage.setItem("tipe_pemohon", "Pemerintah");
      this.$router.push("/app/permohonan/form");
    },

    verifPembayaran(id){
        axios.get(this.baseapiPengendalian + "api/permohonan_nonberusaha/" + id, {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken
            }
          }).then(response => {
            this.dataPerDokumen = response.data.data;
            this.dataPerDokumen['tagihan_i'] = this.dataPerDokumen.file_tagihan_i
            this.dataPerDokumen['tagihan_ii'] = this.dataPerDokumen.file_tagihan_ii
            this.dataPerDokumen['tagihan_iii'] = this.dataPerDokumen.file_tagihan_iii
            console.log(this.dataPerDokumen)
            Swal.fire({
              title: 'Upload Tagihan',
              icon: 'question',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ya'
            }).then((result) => {
              if (result.isConfirmed) {
                this.$bvModal.show('modal-pembayaran')
              }
            })
          }).catch(error => {
            console.log(error)
            return error
          });
      },

      // upload pembayaran
      onSubmitPembayaran() {
        console.log('cok')
        this.$nextTick(() => {
              this.$bvModal.hide('modal-pembayaran')
            });
        this.$loading(true);
        let formData = new FormData();
        if (this.dataPerDokumen.tanggal_tagihan_ii === null && this.dataPerDokumen.tanggal_tagihan_iii === null) {
              formData.append('file_tagihan_i', this.dataPerDokumen.tagihan_i);
              formData.append('tanggal_tagihan_i', this.dataPerDokumen.tanggal_tagihan_i);
        } else if(this.dataPerDokumen.tanggal_tagihan_iii === null) {
              formData.append('file_tagihan_i', this.dataPerDokumen.tagihan_i);
              formData.append('tanggal_tagihan_i', this.dataPerDokumen.tanggal_tagihan_i);
              formData.append('file_tagihan_ii', this.dataPerDokumen.tagihan_ii);
              formData.append('tanggal_tagihan_ii', this.dataPerDokumen.tanggal_tagihan_ii);
        } else {
              formData.append('file_tagihan_i', this.dataPerDokumen.tagihan_i);
              formData.append('tanggal_tagihan_i', this.dataPerDokumen.tanggal_tagihan_i);
              formData.append('file_tagihan_ii', this.dataPerDokumen.tagihan_ii);
              formData.append('tanggal_tagihan_ii', this.dataPerDokumen.tanggal_tagihan_ii);
              formData.append('file_tagihan_iii', this.dataPerDokumen.tagihan_iii);
              formData.append('tanggal_tagihan_iii', this.dataPerDokumen.tanggal_tagihan_iii);
        }

        axios.post(this.baseapiPengendalian + 'api/permohonan_nonberusaha/' + this.dataPerDokumen.id, formData, {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ` + this.user.accessToken
          }
        })
          .then((res) => {
            this.$loading(false);
            this.$toasted.success("Berhasil Ditambah");
            this.$refs.childBendahara.getdata()
            this.dataPerDokumen = []

            // Wait until the models are updated in the UI
            return res;
          })
          .catch((err) => {
            this.$loading(false);
            console.log(err)
            this.$toasted.error(err.response.data.message);
            // this.$bvModal.hide('modal-pembayaran')
            return err;
          });
      },

    loadProgress(id) {
      axios
        .get(
          this.baseapiPengendalian +
            "api/status_permohonan_nonberusaha?filter=id_permohonan,=," +
            id,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.progressPermohonan = response.data.data;
          this.$bvModal.show("modal-tracking");
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    async deleteDokumen(id) {
      Swal.fire({
        title: "Apa kamu yakin?",
        text: "Anda tidak akan dapat mengembalikan data ini!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya, hapus",
        cancelButtonText: "Tutup",
      }).then(async (result) => {
        if (result.isConfirmed) {
          axios
            .delete(this.baseapiPengendalian + "api/permohonan_nonberusaha/" + id, {
              headers: {
                Authorization: `Bearer ` + this.user.accessToken,
              },
            })
            .then((response) => {
              Swal.fire("Berhasil", "" + response.data.message + "", "success");
              this.loaddata()
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },

    initDatatable() {
      setTimeout(() => {
        var t = $("#tablepermohonan").DataTable({
          pagingType: "full_numbers",
          language: {
            info: "Menampilkan _START_ sampai _END_ dari _TOTAL_ data",
            paginate: {
              first: "Awal",
              last: "Akhir",
              next: "Selanjutnya",
              previous: "Sebelumnya",
            },
          },
          // order: [[0, 'desc']],
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true,
          fixedColumns: { left: 2, right: 1 },
          scrollX: true,
          dom: "Bfrtip",
          fnRowCallback: function (
            nRow,
            aData,
            iDisplayIndex,
            iDisplayIndexFull
          ) {
            //debugger;
            var index = iDisplayIndexFull + 1;
            $("td:first", nRow).html(index);
            return nRow;
          },
          columnDefs: [
            {
              targets: 0,
              render: function (data, type, row, meta) {
                // console.log(meta.row);
                // console.log(type == 'export' ? meta.row : data);
                return type == "export" ? meta.row + 1 : data;
              },
              rowCallback: function (row, data, index) {
                console.log(data);
                if (data[0] == "OK") {
                  $(row).addClass("green");
                } else if (data[0] == "Before") {
                  $(row).addClass("orange");
                }
              },
            },
          ],
          buttons: [
            // 'excel', 'pdf',
            // {
            //   text: '<i class="fa fa-plus"></i> Tambah',
            //   className: "btn btn-primary",
            //   action: function (e, dt, node, config) {
            //     localStorage.removeItem("id_permohonan");
            //     localStorage.setItem("tipe_pemohon", "Pemerintah");
            //     window.location = "/app/permohonan/form";
            //   },
            // },
            {
              extend: "excelHtml5",
              title: "DATA PEMOHON",
              text: '<i class="fa fa-file-text-o"></i> Excel',
              className: "btn text-white btn-success",
              exportOptions: {
                columns: [1, 2, 3, 4, 5, 6, 7, 8, 9],
                orthogonal: "export",
              },
              filename: function () {
                var today = new Date();
                // var n = d.getTime();
                var date =
                  today.getFullYear() +
                  "-" +
                  (today.getMonth() + 1) +
                  "-" +
                  today.getDate();

                return "Data Pemohon " + date;
              },
            },
          ],
        });

        t.on("order.dt search.dt", function () {
          t.column(0, { search: "applied", order: "applied" })
            .nodes()
            .each(function (cell, i) {
              cell.innerHTML = i + 1;
            });
        }).draw();
      }, 300);
    },
  },
};
</script>

  <style src="./Elements.scss" lang="scss" />
    